import { useState } from 'react';
import { Container } from 'reactstrap';
import { APIProvider } from '@vis.gl/react-google-maps';
import { faBellConcierge, faRoadCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from '@s20/hooks/redux.hooks';
import { getTenantSettings } from '@s20/selectors/features/common.selectors';
import { BottomNavBar } from '../BottomNavBar';
import { NavAction } from '../../NavMenu/NavAction';
import { FormValidated } from '../../common/forms/FormElements';
import { DatePicker } from '../../common/forms/DatePicker';
import { useQueryParam } from '../../hooks/useQueryParam';
import { RequestJobForm } from './RequestJobForm';
import { MapView } from './MapView';
import { MyJobs } from './MyJobs';

export const CustomerPortal = () => {
    const [showRequestJobForm, setShowRequestJobForm] = useState(false);
    const [showMyJobs, setShowMyJobs] = useState(false);

    const tenantSettings = useSelector(getTenantSettings);

    const timesheetId = useQueryParam('t') || null;
    const defaultTimesheetId = timesheetId ? parseFloat(timesheetId) : null;

    return (
        <FormValidated
            className="d-flex flex-column w-100"
            id="customerPortalSearch"
            initialValues={{
                defaultTimesheetId,
                jobDate: new Date(),
                selectedJobId: defaultTimesheetId,
            }}
        >
            {({ setFieldValue }) => (
                <>
                    <header className="flex-none">
                        <Container>
                            <DatePicker
                                name="jobDate"
                                label="Select a date"
                                onChange={() => setFieldValue('selectedJobId', null)}
                            />
                        </Container>
                    </header>

                    <div className="d-flex flex-fill flex-nowrap">
                        <APIProvider
                            apiKey={tenantSettings.googleMapsApiKey}
                            libraries={['marker', 'geometry']}
                            version="quarterly"
                        >
                            <MapView
                                mapId={tenantSettings.mapId}
                                defaultTimesheetId={defaultTimesheetId}
                            />
                        </APIProvider>
                    </div>

                    <BottomNavBar>
                        <NavAction
                            onClick={() => setShowRequestJobForm(true)}
                            label="Request a Job"
                            icon={faBellConcierge}
                        />

                        <NavAction
                            onClick={() => setShowMyJobs(true)}
                            label="My Jobs"
                            icon={faRoadCircleCheck}
                        />
                    </BottomNavBar>

                    <MyJobs
                        show={showMyJobs}
                        onClose={() => setShowMyJobs(false)}
                    />

                    <RequestJobForm
                        show={showRequestJobForm}
                        onClose={() => setShowRequestJobForm(false)}
                    />
                </>
            )}
        </FormValidated>
    );
};